import useSWR from 'swr';
import api from '../../services/api';

export interface NotificationRecord {
  id: number;
  userId: number;
  entityType: string;
  entityId: number;
  message: string;
  link?: string | null;
  createdAt: string;
  readAt?: string | null;
}

export interface NotificationFilters {
  type?: string;
  read?: boolean;
  limit?: number;
}

const fetcher = async (url: string) => {
  const response = await api.get(url);
  return response.data;
};

export const useNotificationsList = (filters?: NotificationFilters) => {
  const params = new URLSearchParams();
  if (filters?.type) params.append('type', filters.type);
  if (filters?.read !== undefined) params.append('read', String(filters.read));
  params.append('limit', String(filters?.limit ?? 200));
  const queryString = params.toString();
  const url = `/notifications${queryString ? `?${queryString}` : ''}`;

  const { data, error, isLoading, mutate } = useSWR<NotificationRecord[]>(url, fetcher, {
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
  });

  return {
    data: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const useNotificationRecord = (id: number | null) => {
  const { data, error, isLoading, mutate } = useSWR<NotificationRecord>(
    id ? `/notifications/${id}` : null,
    fetcher,
    { revalidateOnFocus: true }
  );

  return {
    data,
    isLoading,
    isError: error,
    mutate,
  };
};

export const updateNotificationRecord = async (
  id: number,
  body: { message?: string; link?: string; readAt?: string | null }
) => {
  const { data } = await api.patch<NotificationRecord>(`/notifications/${id}`, body);
  return data;
};
